module.exports = __webpack_public_path__ + "img/prize-02.22e44fe3.png";